module.exports = __webpack_public_path__ + "img/dangerous-breeds-ua.67d7315b.svg";